
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.789 47.745c-.15 0-.31-.04-.45-.11a.994.994 0 01-.55-.886v-4.6h-1.13c-3.81 0-6.919-3.086-6.919-6.889V19.241c0-3.793 3.1-6.889 6.92-6.889h28.165c3.81 0 6.919 3.086 6.919 6.89V35.26c0 3.793-3.1 6.89-6.92 6.89H25.759l-7.37 5.405c-.18.13-.39.19-.6.19zm-2.13-33.402c-2.71 0-4.92 2.2-4.92 4.898v16.02c0 2.697 2.21 4.897 4.92 4.897h2.13a1 1 0 011 .996v3.624l6.039-4.43a.97.97 0 01.59-.19h18.397c2.71 0 4.92-2.2 4.92-4.898V19.241c0-2.698-2.21-4.898-4.92-4.898H15.659z"}})])
          )
        }
      }
    